<template>
    <section class="section">
        <h2 class="section-header">Прозрачная стоимость занятий</h2>

        <div class="prices container">
            <template
                    v-for="lessonType in lessonTypes"
            >

                <IndividualLessonPrices :lesson-type="lessonType"
                                        v-if="lessonType.type === 'individual'"
                ></IndividualLessonPrices>
                <GroupLessonPrices
                    :lesson-type="lessonType"
                    v-if="lessonType.type === 'group'"
                ></GroupLessonPrices>
                <ClubsLessonPrices
                    :lesson-type="lessonType"
                    v-if="lessonType.type === 'clubs'"
                ></ClubsLessonPrices>
            </template>
        </div>
    </section>
</template>

<script>
    import LessonType from './LessonType';
    import IndividualLessonPrices from './IndividualLessonPrices';
    import GroupLessonPrices from './GroupLessonPrices';
    import ClubsLessonPrices from './ClubsLessonPrices';

    export default {
        name: "Prices",

        components: {
            LessonType, IndividualLessonPrices, GroupLessonPrices, ClubsLessonPrices,
        },

        data(){
            return {
                lessonTypes: [],
            };
        },

        created(){
            this.loadLessonTypes();
        },

        methods: {
            loadLessonTypes(){
                return new Promise(resolve => {
                    if(window.lessonTypes){
                      this.lessonTypes = lessonTypes;
                      resolve(window.lessonTypes);
                    }else {
                      $.get('/wp-json/api/v1/lesson-types', lessonTypes => {
                        this.lessonTypes = lessonTypes;
                        resolve(lessonTypes);
                      });
                    }
                });
            },
        },
    }
</script>

<style scoped>

</style>